var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-container',[_c('v-row',[_c('v-col',{class:_vm.classObject},[_c('before-after-image',{attrs:{"before-image":_vm.imageBackground,"after-image":_vm.imageForeground}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }